import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { createBreeding } from "../../../api/breeding";
import { fetchAccountStorage } from "../../../api/profile";
import { CreateBreeding } from "../../../generated/types";
import { Button } from "../../common/Button";
import {
  BreedingFields,
  EMPTY_BREEDING_FORM,
  useBreedingForm,
} from "../breeding/BreedingFields";
import { setupBuildingsPath } from "./setupRoutes";
import { SetupError, SetupLayout } from "./SetupLayout";

// Clés passées en props à SetupLayout, invisibles du parser sans ces marqueurs.
// i18n.t("setup-breeding-title")
// i18n.t("setup-breeding-intro")
export const SetupBreedingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const breedingForm = useBreedingForm(EMPTY_BREEDING_FORM);
  const [companyId, setCompanyId] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  // L'entreprise est celle du compte : on ne la demande pas, on la lit.
  useEffect(() => {
    let cancelled = false;
    fetchAccountStorage()
      .then((profile) => {
        if (!cancelled) setCompanyId(profile.company.id);
      })
      .catch(() => {
        if (!cancelled) setError(t("setup-error-company"));
      });
    return () => {
      cancelled = true;
    };
  }, [t]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!breedingForm.validate()) {
      return;
    }
    if (!companyId) {
      setError(t("setup-error-company"));
      return;
    }

    setSubmitting(true);
    const payload: CreateBreeding = {
      ...breedingForm.form,
      country: "FR",
      id_company: companyId,
    };
    const result = await createBreeding(payload);
    setSubmitting(false);

    if (!result.success || !result.breedingId) {
      setError((result.error && t(result.error)) || t("setup-error-breeding"));
      return;
    }
    navigate(setupBuildingsPath(result.breedingId));
  };

  return (
    <SetupLayout
      step={1}
      titleKey="setup-breeding-title"
      introKey="setup-breeding-intro"
    >
      <form onSubmit={submit} className="space-y-4">
        <SetupError message={error} />

        <BreedingFields breedingForm={breedingForm} />

        <Button type="submit" size="full" disabled={submitting}>
          {submitting ? t("setup-saving") : t("setup-next")}
        </Button>
      </form>
    </SetupLayout>
  );
};
